import React, { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import axios from "api/baseurl";

import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  Pagination,
    Chip,
} from "@mui/material";

import { keyframes } from "@mui/system";
import { useNavigate } from "react-router-dom";

function AlertReviewScreen() {
  const [loading, setLoading] = useState(true);
  const [alertData, setAlertData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const navigate = useNavigate();

  const token = JSON.parse(localStorage.getItem("loginData"))?.token;
const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;
    const role = loginData?.role;
  // ================= FETCH API =================
  const fetchAlertReview = async (pageNumber = 1) => {
    try {
      setLoading(true);

      const response = await axios.get(
        `/api/patientregistration/dutyreviewall/${userid}`,
        {
          params: {
            page: pageNumber - 1,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("API Response:", response.data);

      setAlertData(response.data.content || []);
      setCurrentPage(response.data.currentPage + 1);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAlertReview(currentPage);
  }, [currentPage]);

  // ================= PAGINATION =================
  const handlePageChange = (_, page) => {
    setCurrentPage(page);
  };

  // ================= CARD CLICK =================
  const handleCardClick = (patientId) => {
    navigate("/ViewPatientReadingsPage", {
      state: { patientId },
    });
  };

  // ================= LOADER =================
  const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;

  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* ================= LOADER ================= */}
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255,255,255,0.7)",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: 70,
              height: 70,
              animation: `${spinAnimation} 1.5s linear infinite`,
            }}
          >
            {dotPositions.map((pos, index) => (
              <Box
                key={index}
                sx={{
                  width: 7,
                  height: 7,
                  borderRadius: "50%",
                  backgroundColor: "#1A237E",
                  position: "absolute",
                  ...pos,
                }}
              />
            ))}
          </Box>
        </Box>
      )}

      {/* ================= TITLE ================= */}
      <Box mt={2} mb={3}>
        <Typography
          variant="h5"
          sx={{
            color: "#1A237E",
            fontWeight: 600,
            fontSize: "22px",
          }}
        >
          Alert Review Details
        </Typography>
      </Box>

      {/* ================= CARD VIEW ================= */}
      <Grid container spacing={2.5}>
        {alertData.map((patient, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              onClick={() => handleCardClick(patient.patientId)}
              sx={{
                borderRadius: "14px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                transition: "all 0.3s ease",
                background: "#fff",
                height: "100%",
                border: "1px solid #f1f1f1",
                cursor: "pointer",

                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 20px rgba(26, 35, 126, 0.18)",
                  backgroundColor: "#f5f7ff",
                  border: "1px solid #d6dcff",
                },
              }}
            >
             <CardContent
  sx={{
    padding: "18px !important",
  }}
>
  {/* Header */}
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      mb: 2,
    }}
  >
    {/* Patient */}
    <Box>
      <Typography
        sx={{
          fontSize: "17px",
          fontWeight: 700,
          color: "#1A237E",
          textTransform: "capitalize",
          lineHeight: 1.2,
        }}
      >
        {patient.patientName}
      </Typography>

      <Typography
        sx={{
          fontSize: "12px",
          color: "#777",
          mt: 0.5,
        }}
      >
        {patient.gender} • {patient.age} Years
      </Typography>
    </Box>

    {/* Severity Badge */}
    <Chip
      label={patient.alertSeverity || "NORMAL"}
      size="small"
      sx={{
        fontWeight: 700,
        fontSize: "11px",
        backgroundColor:
          patient.alertSeverity === "HIGH"
            ? "#FFEBEE"
            : patient.alertSeverity === "MEDIUM"
            ? "#FFF8E1"
            : "#E8F5E9",

        color:
          patient.alertSeverity === "HIGH"
            ? "#C62828"
            : patient.alertSeverity === "MEDIUM"
            ? "#EF6C00"
            : "#2E7D32",
      }}
    />
  </Box>

  {/* Alert Subject */}
  <Box sx={{ mb: 1.5 }}>
    <Typography
      sx={{
        fontSize: "12px",
        color: "#888",
        fontWeight: 600,
        mb: 0.5,
        textTransform: "uppercase",
        letterSpacing: "0.5px",
      }}
    >
      Alert Subject
    </Typography>

    <Typography
      sx={{
        fontSize: "14px",
        fontWeight: 600,
        color: "#222",
        lineHeight: 1.5,
      }}
    >
      {patient.alertSubject || "-"}
    </Typography>
  </Box>

  {/* Alert Message */}
  <Box sx={{ mb: 2 }}>
    <Typography
      sx={{
        fontSize: "12px",
        color: "#888",
        fontWeight: 600,
        mb: 0.5,
        textTransform: "uppercase",
        letterSpacing: "0.5px",
      }}
    >
      Alert Message
    </Typography>

    <Typography
      sx={{
        fontSize: "13px",
        color: "#555",
        lineHeight: 1.6,
      }}
    >
      {patient.alertMessage || "-"}
    </Typography>
  </Box>

  {/* Footer */}
  <Box
    sx={{
      borderTop: "1px solid #f1f1f1",
      pt: 1.5,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <Typography
      sx={{
        fontSize: "11px",
        color: "#999",
        fontWeight: 500,
      }}
    >
      Alert Time
    </Typography>

    <Typography
      sx={{
        fontSize: "12px",
        color: "#444",
        fontWeight: 600,
      }}
    >
      {patient.alertTimestamp
        ? new Date(
            patient.alertTimestamp
          ).toLocaleString()
        : "-"}
    </Typography>
  </Box>
</CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* ================= PAGINATION ================= */}
      <Box mt={4} display="flex" justifyContent="center">
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          color="primary"
          sx={{
            "& .MuiPaginationItem-root": {
              borderRadius: "5px",
              color: "#1A237E",
              fontSize: "14px",
            },

            "& .Mui-selected": {
              backgroundColor: "#1A237E !important",
              color: "#fff",
            },
          }}
        />
      </Box>
    </DashboardLayout>
  );
}

export default AlertReviewScreen;